import api from 'service/api'
import * as service from 'service'

import auth from './auth'

const dponetAPI = api.create('dponet', false)

const validateCode = async (data, scope = 'login') => {
  const validateCodeResponse = await dponetAPI.post('/2FA/validate', {
    ...data,
    scope,
  })

  // Apenas atualiza sessão para o escopo de login
  if (validateCodeResponse.status === 200 && scope === 'login') {
    const token = validateCodeResponse.data.authToken

    auth.setToken(token)

    const identifyResponse = await service.dponet.usersCompanies.identify()
    if (identifyResponse.data?.company)
      auth.setCompany(identifyResponse.data.company)
  }

  return validateCodeResponse
}

const resendCode = async (data, scope = 'login') => {
  return await dponetAPI.post('/2FA/resend', {
    ...data,
    scope,
  })
}

export default {
  validateCode,
  resendCode,
}
